export const FORM = 'form'
export const USER = 'user'
export const VALIDATION = 'validation'
export const DROPDOWN_LIST = 'dropdownList'
export const TABLE = 'table'
